
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEnergy = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 60,
  height: 60,
  viewBox: "0 0 1201 1200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M508.933 1059.35c12.211 5.22 26.409.86 33.541-10.41l324.519-515.621c5.255-8.346 5.573-18.884.819-27.493a27.05 27.05 0 0 0-23.69-13.997H627.537l80.55-319.668c3.249-12.914-3.328-26.252-15.556-31.507-12.147-5.229-26.435-.846-33.54 10.404l-324.52 515.625c-5.255 8.346-5.572 18.884-.818 27.493a27.05 27.05 0 0 0 23.69 13.997h216.584l-80.549 319.667c-3.249 12.92 3.326 26.25 15.555 31.51z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"60\" height=\"60\" viewBox=\"0 0 1201 1200\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"M508.933 1059.35c12.211 5.22 26.409.86 33.541-10.41l324.519-515.621c5.255-8.346 5.573-18.884.819-27.493a27.05 27.05 0 0 0-23.69-13.997H627.537l80.55-319.668c3.249-12.914-3.328-26.252-15.556-31.507-12.147-5.229-26.435-.846-33.54 10.404l-324.52 515.625c-5.255 8.346-5.572 18.884-.818 27.493a27.05 27.05 0 0 0 23.69 13.997h216.584l-80.549 319.667c-3.249 12.92 3.326 26.25 15.555 31.51z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/energy.f2dce949ff7bbe5f43f5fffd5af3a82b.svg"),
        {
          React: SvgEnergy,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      